import { render, staticRenderFns } from "./SpirometriaEdit.vue?vue&type=template&id=47e0b63a"
import script from "./SpirometriaEdit.vue?vue&type=script&lang=js"
export * from "./SpirometriaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports